// DAPP-only principal withdrawal restriction. The deployed participation
// contracts do not consult this policy; it is not an on-chain freeze.
// Keep reward claims, participation, and ledger balances independent of it.
const PRINCIPAL_WITHDRAWAL_BLOCKED_ADDRESSES = new Set([
  "0x62ee2ed51781997d7008ee93b009473d1a48a19e",
  "0xf1adfc995a65f5f7ec1fd985fc69e10d877244f0",
  "0x052fa8229c3dd80e3966958be33d93d480684e7d",
  "0x841ffbe772e8a5e322e20234a49490744b0d1df8",
  "0x2364ecace8d17ca4d0551bc1bb401d6b183c5f6b",
  "0x23ecccf0590f9f5b8f2046d02b904e2b7b83b282",
  "0x64ae26a139dcd0c6e6b4f9dbf9c659aa17498278",
  "0x5e530cf5d423bd0f1ec49fdb547f0e593a88d677",
  "0x754f023eb9599400509b744b85da3807461458f7",
  "0x36cf21043534502da236f1a45cf668d36746d65a",
  "0xefbebc180efa945881b650902dc72bbdecf5a20b",
  "0xc5af961277ab7699eddcec33000c16ff9d7f031b",
  "0xc353d42d310a1736290797edc7a316359b68c6cf",
  "0xf8f66e18706dee06b36d7c70b669858532b2d8ce",
  "0xf7d19fe02f8d6de6876c547a2e80001cd61a0dda",
  "0x3b4d34fccef1f99b4219865ed302eaf0c856213a",
  "0x55748b33f10d8076c9c12378c08e3b2ff940475b",
  "0x3ba33f2395754c86efbf41a3340e4804eab0bbbf",
  "0xa3d4580b8cc074e3684e16aef87cd573d81448ef",
  // Explicitly requested principal restrictions, independent of resumable
  // earnings pauses. Resuming earnings does not automatically remove these.
  "0xc05fdd205b45b48376bb6ce8ebb15560ba2c987b",
  "0x08d0167b7b8a2afa719874f6e1b0dccda76238e4",
  "0x6e12a848e6af86a312cbb08085fb69ccfa90db41",
  "0xe9887f72a5fd6baa9f809655d2ec8a993520c98e",
  "0xb15992ea33f3c1a4a9dfda490f32aa3bdc090a37",
  "0xf9b473399fd8e8f0893982a93f5fed5fd5467d4a",
  "0xec9b8a867258b18a98951b6439fbcbf4decbe468",
  "0x8eec6429b4f9173c9418700a56be2c12932f1454",
  "0xe4d3cfe277a8d14773a673b7bad8f69c9c7e5fb5"
]);

export function isPrincipalWithdrawalBlocked(...addresses: Array<string | null | undefined>): boolean {
  return addresses.some((address) => (
    PRINCIPAL_WITHDRAWAL_BLOCKED_ADDRESSES.has(address?.trim().toLowerCase() ?? "")
  ));
}

export function assertPrincipalWithdrawalAllowed(...addresses: Array<string | null | undefined>): void {
  if (isPrincipalWithdrawalBlocked(...addresses)) {
    throw new Error("本金提取已限制");
  }
}
